export default __webpack_public_path__ + "static/media/lightning-no.527a1315.svg";